var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m15 16.19-3.78-3.97a.69.69 0 0 0-1.01 0 .777.777 0 0 0 0 1.06l4.285 4.5a.69.69 0 0 0 1.01 0l4.286-4.5a.777.777 0 0 0 0-1.06.69.69 0 0 0-1.01 0L15 16.19Z",
    id: "chevron_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    transform: "rotate(-90 4 16)",
    xlinkHref: "#chevron_svg__a",
    fillRule: "evenodd"
  })));
};
export default SvgChevron;